import React from 'react';
import {Field} from 'redux-form';
import {Form, Row, Col} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import * as fields from 'components/common/fields';
import * as validators from 'utils/validators';
import {makeForm} from 'utils/common';

class BookForm extends React.Component {
  render() {
    const {handleSubmit, pristine, submitting} = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={6}>
            <Field name="title" label="Title" component={fields.Input} required validate={[validators.isRequired]} />
          </Col>
          <Col md={6}>
            <Field name="author" label="Author" component={fields.Input} />
          </Col>
          <Col md={6}>
            <Field name="publisher" label="Publisher" component={fields.Input} />
          </Col>
          <Col md={6}>
            <Field name="isbn" label="ISBN" component={fields.Input} validate={[validators.isISBN]} />
          </Col>
          <Col md={6}>
            <Field
              name="yearPublished"
              label="Year Published"
              component={fields.Input}
              validate={[validators.isYear]}
            />
          </Col>
          <Col md={6}>
            <Field name="illustrator" label="Illustrator" component={fields.Input} />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={pristine || submitting}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = (state) => {
  const currentBook = state.books.get('currentBook').toJS();
  return {
    initialValues: currentBook,
  };
};

export default {
  Creation: makeForm(BookForm, 'BookForm.Creation', null, null),
  Update: makeForm(BookForm, 'BookForm.Update', mapStateToProps, null),
};
